module.exports = __webpack_public_path__ + "static/media/icon.eb52d362.svg";